import { memo, ReactNode } from 'react';
import { css } from '@emotion/react';
import { Icon } from '@frontend/icons';
import { theme } from '@frontend/theme';
import { Text } from '@frontend/design-system';
import { AIInsightIconSVG } from '../../assets/images';

type ChartInsightCardProps = {
  className?: string;
  leftIcon?: ReactNode;
  subtitle?: ReactNode;
  title: ReactNode;
  muted?: boolean;
  trackingId?: string;
};
export const ChartInsightCard = memo(
  ({ className, leftIcon, subtitle, title, muted, trackingId }: ChartInsightCardProps) => {
    const renderTextNode = (content: ReactNode, textCss: ReturnType<typeof css>) =>
      typeof content === 'string' ? <Text css={textCss}>{content}</Text> : content;

    return (
      <div className={className} css={styles.wrapper} data-tracking-id={trackingId}>
        {leftIcon || (muted ? <Icon name='ai-idea' width={24} height={24} color='subdued' /> : <AIInsightIconSVG />)}
        <div css={styles.content}>
          {renderTextNode(title, styles.titleText)}
          {subtitle && renderTextNode(subtitle, styles.subtitleText)}
        </div>
      </div>
    );
  }
);

ChartInsightCard.displayName = 'ChartInsightCard';

const styles = {
  wrapper: css`
    display: flex;
    gap: ${theme.spacing(1)};
    align-items: center;
    padding: ${theme.spacing(3, 1)};
    border-top: 1px solid ${theme.colors.neutral20};
    margin: ${theme.spacing(0, 3)};
  `,
  content: css`
    display: flex;
    flex-direction: column;
    gap: ${theme.spacing(1)};
  `,

  titleText: css`
    font-weight: ${theme.font.weight.bold};
    font-size: ${theme.font.size.medium};
  `,
  subtitleText: css`
    color: ${theme.colors.neutral50};
    font-size: ${theme.font.size.small};
  `,
};
